import { createFileRoute } from "@tanstack/react-router";
import { BusinessLanding } from "./foretag.index";

const TITLE = "Vende como empresa en Sellavo – perfil de empresa gratis";
const DESCRIPTION =
  "Crea un perfil de empresa en Sellavo, muestra tus condiciones y llega a compradores con una página verificada con todos tus anuncios.";

export const Route = createFileRoute("/es/empresas")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/empresas" }],
  }),
  component: BusinessLanding,
});
